export default __webpack_public_path__ + "images/1a1666fbbbb7290031d61de5f2c0d709-fashion.webp";